export default __webpack_public_path__ + "static/media/James.33e8d180.JPG";